import React, { useState } from 'react';
import EnhancedAuthModal from './EnhancedAuthModal';

const EnhancedSignupDemo = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Enhanced Sign-up Form Demo
          </h1>
          <p className="text-gray-600 mb-6">
            This is the new enhanced sign-up form that matches the card format used for doctors and providers.
            It includes profile picture upload, real-time preview, and comprehensive field collection.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="text-4xl mb-3">👤</div>
              <h3 className="font-semibold text-gray-900 mb-2">User Registration</h3>
              <p className="text-sm text-gray-600">Personal info, insurance details, medical history</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="text-4xl mb-3">👨‍⚕️</div>
              <h3 className="font-semibold text-gray-900 mb-2">Doctor Registration</h3>
              <p className="text-sm text-gray-600">Professional details, specializations, qualifications, live card preview</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <div className="text-4xl mb-3">🏥</div>
              <h3 className="font-semibold text-gray-900 mb-2">Provider Registration</h3>
              <p className="text-sm text-gray-600">Facility information, services, location, features, live card preview</p>
            </div>
          </div>
          
          <button
            onClick={() => setShowModal(true)}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium text-lg"
          >
            Try Enhanced Sign-up Form
          </button>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm border p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">New Features:</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="bg-green-100 text-green-600 p-1 rounded">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Profile Picture Upload</h4>
                  <p className="text-sm text-gray-600">Upload during registration or add later</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="bg-green-100 text-green-600 p-1 rounded">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Live Card Preview</h4>
                  <p className="text-sm text-gray-600">See how your profile card will look</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="bg-green-100 text-green-600 p-1 rounded">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Card-Inspired Design</h4>
                  <p className="text-sm text-gray-600">Layout matches doctor/provider card format</p>
                </div>
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <div className="bg-green-100 text-green-600 p-1 rounded">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Comprehensive Fields</h4>
                  <p className="text-sm text-gray-600">All fields needed for complete profiles</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="bg-green-100 text-green-600 p-1 rounded">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Professional Layout</h4>
                  <p className="text-sm text-gray-600">Two-column responsive design</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="bg-green-100 text-green-600 p-1 rounded">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">Smart Validation</h4>
                  <p className="text-sm text-gray-600">Context-aware field requirements</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <EnhancedAuthModal 
        isOpen={showModal} 
        onClose={() => setShowModal(false)} 
        defaultTab="register"
      />
    </div>
  );
};

export default EnhancedSignupDemo;